export default __webpack_public_path__ + "static/media/meatballs.28323643.svg";